import React, { memo, useState, useRef } from 'react'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useQuery } from '@apollo/react-hooks'

import styles from './styles'
import Editor from './component'
import { IJobEditorWrapper } from 'models'
import { S3GetEditorHashQuery, StoreValue } from 'store'
import { jobsFolder } from 'utils'

const useStyles = makeStyles(styles)

const JobEditorView: React.FunctionComponent<IJobEditorWrapper> = props => {
	const {
		textCategory,
		persistentPreview,
		previewBenefits,
		previewDescription,
		editable = true,
	} = props
	// TODO: previewBenefits and previewDescription are temporary solutions, remove them and store the data in store

	const containerRef = useRef(null)
	const theme: Theme = useTheme()
	const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))
	const classes = useStyles()
	const [preview, toggle] = useState(true)
	const { data } = useQuery(S3GetEditorHashQuery, {
		variables: {
			keyStart: jobsFolder + '/',
		},
	})
	let s3UploadHash = null
	if (data && data.getS3UploadHash) {
		s3UploadHash = {
			bucket: data.getS3UploadHash.bucket,
			keyStart: data.getS3UploadHash.keyStart,
			region: data.getS3UploadHash.region,
			params: {
				acl: data.getS3UploadHash.params.acl,
				policy: data.getS3UploadHash.params.policy,
				'x-amz-algorithm': data.getS3UploadHash.params.XAmzAlgorithm,
				'x-amz-credential': data.getS3UploadHash.params.XAmzCredential,
				'x-amz-date': data.getS3UploadHash.params.XAmzDate,
				'x-amz-signature': data.getS3UploadHash.params.XAmzSignature,
			},
		}
	}
	const done = () => {
		toggle(true)
	}
	const edit = () => {
		if (!preview) return null
		toggle(false)
	}
	let style: any = {}

	if (preview) {
		style.overflow = 'auto'
	}

	if (!preview && isDownSm) {
		style.position = 'fixed'
		style.margin = 0
		// style.padding = 15
	}

	return (
		<div
			ref={containerRef}
			className={classes.activeContainer}
			style={style}
			onClick={!editable ? undefined : edit}
		>
			{s3UploadHash && (
				<Editor
					s3UploadHash={s3UploadHash}
					isDownSm={isDownSm}
					preview={preview}
					done={done}
					containerRef={containerRef}
					textCategory={textCategory}
					persistentPreview={persistentPreview}
					previewBenefits={previewBenefits}
					previewDescription={previewDescription}
				/>
			)}
		</div>
	)
}

const JobEditor = memo((props: IJobEditorWrapper) => (
	<StoreValue keys={['job.error|error']}>
		<JobEditorView {...props} />
	</StoreValue>
))

export default JobEditor
